<template>
  <div class="container-fluid">
    <b-table
      :id="id"
      striped
      show-empty
      empty-text="Não existem resultados para essa busca"
      :per-page="pagination.perPage"
      :current-page="pagination.currentPage"
      :items="get"
      :fields="fields"
    >
      <template #cell(actions)="row">
        <b-button v-if="$can('update', resource)" variant="secondary" size="sm" v-on:click="edit(row)">
          <i class="fas fa-pen"></i>
        </b-button>
        <b-button v-if="$can('delete', resource)" variant="danger" size="sm" class="mr-1" v-on:click="destroy(row)">
          <i class="fas fa-trash"></i>
        </b-button>
        <b-button v-if="$can('restore', resource)" variant="info" size="sm" class="mr-1">
          <i class="fas fa-undo"></i>
        </b-button>
      </template>
    </b-table>

    <b-pagination
      align="center"
      v-model="pagination.currentPage"
      :aria-controls="id"
      :per-page="pagination.perPage"
      :total-rows="pagination.totalRows"
    ></b-pagination>
  </div>
</template>

<script>
import Vue from "vue"
import { v4 as uuidv4 } from 'uuid'

export default Vue.extend({
  props: {
    resource: {},
    fields: {
      required: true
    },
    provider: {},
    apiUrl: {},
  },
  created() {
    this.id = uuidv4() + '-table'
  },
  data() {
    return {
      pagination: {
        perPage: 0,
        currentPage: 1,
        totalRows: 0,
      },
    }
  },
  methods: {
    async get(_) {
      return this.provider(this.pagination)
    },
    edit(row) {
      this.$emit('edit', row.item)
    },
    destroy(row) {
      this.$emit('delete', row.item)
    },
  },
  mounted() {
    console.log(this.$can('read', 'admins'))
  }
});
</script>
